module.exports = __webpack_public_path__ + "static/media/italian pepper.8a996873.png";